
function formatConfig(config) {
 return {
   active:config.active,
   name: config.name,
 }
}

export const formatResponses = {
  formatConfig: (user) => formatConfig(user),

};
